import React from 'react';
import { BarChart3, TrendingUp, Target } from 'lucide-react';

/**
 * DashboardLoadingScreen - Écran de chargement réutilisable pour tous les dashboards
 *
 * Props:
 * - platformName: Nom de la plateforme (ex: "Google Ads", "Microsoft Ads", "Facebook Ads")
 * - platformLogo: URL ou élément du logo (optionnel)
 * - features: Array de 3 features à afficher [{icon: <Component />, label: 'Métriques de performance'}, ...]
 * - progress: Progression optionnelle (0-100). Si fourni, utilise une barre de progression dynamique
 */
const DashboardLoadingScreen = ({
  platformName = 'Dashboard',
  platformLogo = null,
  features = [
    { icon: <BarChart3 size={28} />, label: 'Métriques de performance' },
    { icon: <TrendingUp size={28} />, label: 'Tendances et graphiques' },
    { icon: <Target size={28} />, label: 'Analyse des campagnes' }
  ],
  progress = null
}) => {
  return (
    <div className="dashboard-loading" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px',
      minHeight: '400px'
    }}>
      <h3 style={{
        margin: '0 0 16px 0',
        fontSize: '1.8em',
        color: '#1f2937',
        fontWeight: '600'
      }}>
        Chargement du dashboard
      </h3>

      <p style={{
        color: '#6b7280',
        fontSize: '1.1em',
        marginBottom: '32px',
        textAlign: 'center',
        maxWidth: '500px'
      }}>
        Récupération et analyse de vos données {platformName}...
      </p>

      <div className="loading-progress" style={{ marginBottom: '32px', width: '100%', maxWidth: '400px' }}>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={progress !== null
              ? { width: `${progress}%`, transition: 'width 0.5s ease-out' }
              : { animation: 'progress 10s ease-out forwards' }
            }
          ></div>
        </div>
      </div>

      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px',
        maxWidth: '600px',
        width: '100%'
      }}>
        {features.map((feature, index) => (
          <div key={index} style={{
            textAlign: 'center',
            padding: '16px',
            background: '#FAF9F5',
            borderRadius: '8px'
          }}>
            <div style={{ fontSize: '1.5em', marginBottom: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {feature.icon}
            </div>
            <div style={{ fontSize: '0.9em', color: '#4b5563' }}>{feature.label}</div>
          </div>
        ))}
      </div>

      <div style={{
        marginTop: '24px',
        fontSize: '0.9em',
        color: '#9ca3af'
      }}>
        <small>Cela ne prendra que quelques secondes...</small>
      </div>
    </div>
  );
};

export default DashboardLoadingScreen;
